package de.oevbs.kunde.kundenportal2.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.BankAccount
import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.bankName
import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.iban
import de.oevbs.kosmos.ui.elements.button.Btn
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.forms.inputgroup.inputText
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.Formats
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.navigation.Page
import dev.fritz2.core.RenderContext
import dev.fritz2.core.storeOf
import dev.fritz2.core.invoke
import dev.fritz2.headless.validation.Severity
import dev.fritz2.validation.valid
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull

fun RenderContext.bankAccountsPage(page: Page) {

    val bankAccountsStore = BankAccountsStore(job)

    headerImageLayout {
        title(page.linkTitle)
        content {
            bankAccountsStore.progress.data.render { step ->
                when (step) {
                    GeneralProgressStep.SUBMIT1 -> { //FIXME Das InitSpinning überall mit in die Steps rein?
                        bankAccountsStore.initBankAccountsModel()
                        globalInitTracker.data.combine(bankAccountsStore.initFailedFlow, ::Pair).render initing@{ (loading, failed) ->
                            if (loading) return@initing
                            when {
                                failed -> noPartnerDataFoundMessage()
                                else -> bankAccountsList(bankAccountsStore)
                            }
                        }
                    }

                    GeneralProgressStep.SUCCESS2 -> messagePagePre(
                        header = "Änderung erfolgreich gespeichert.",
                        severity = Severity.Success,
                        preContent = PortalContactNotes.BankAccountChanged(
                            bankAccountsStore.lastChangedBankAccount.current?.iban ?: ""
                        ).note
                    )
                }
            }
        }
    }
}

private fun RenderContext.bankAccountsList(store: BankAccountsStore) {
    div("flex flex-col gap-4") {
        paragraph {
            +"""Hier können Sie Ihre Bankverbindungen anpassen. Bitte beachten Sie, dass eine Änderung sofort
                | auf die betroffenen Verträge mit der Öffentlichen angewendet und die IBAN überschrieben wird. Sollten
                | Sie Kranken- oder Rechtschutzversicherungen bei unseren Produktpartnern haben, müssen Sie diese
                | gesondert über Ihre neue Bankverbindung informieren""".trimMargin()
        }
        paragraph {
            +"Es können aktuell nur deutsche IBANs verwendet werden. Wenn Sie eine ausländische Bankverbindung"
            +" verwenden möchten, senden Sie uns eine Mail an "
            inlineLink(
                text = "service@oeffentliche.de",
                link = "mailto:service@oeffentliche.de",
            )
            +"."

        }
        store.data.renderEach(idProvider = BankAccount::id) {
            div {
                bankAccountCard(it, store)
            }
        }
    }
}

private fun RenderContext.bankAccountCard(initialAccount: BankAccount, listStore: BankAccountsStore) {
    val editStore = BankAccountStore(initialAccount, listStore, job)
    val isEditingStore = storeOf(false)

    val ibanStore = editStore.map(BankAccount.iban() + Formats.iban)
    val initialIban = ibanStore.current

    val bankNameStore = editStore.map(BankAccount.bankName())
    val initialBankName = bankNameStore.current

    editStore.submitChangeBankAccountRequestIfValid
        .mapNotNull { success -> if (success) false else null }
        .handledBy(isEditingStore.update)

    card {
        div("flex flex-col xl:flex-row items-start gap-4") {
            ibanStore.data.map { iban ->
                if (iban != initialIban) "Wird vom System ermittelt"
                else initialBankName
            } handledBy bankNameStore.update

            div("w-full xl:w-auto xl:grow") {
                inputText {
                    label("IBAN")
                    value(ibanStore)
                    disabled(isEditingStore.data.map { !it })
                    iconClickableWithPopover(MaterialIconsOutlined.help, HelpPopovers.iban)
                }
            }

            div("w-full xl:w-auto xl:grow") {
                inputText {
                    label("Name der Bank")
                    value(bankNameStore)
                    disabled(true)
                }
            }

            div("flex gap-4 mt-2 xl:mt-6") {
                btn {
                    label(isEditingStore.data.map { if (it) "Speichern" else "Bearbeiten" })
                    busy(globalSubmitTracker.data)
                    disabled(
                        combine(
                            isEditingStore.data,
                            editStore.data,
                            editStore.messages.valid
                        ) { isEditing, account, isValid ->
                            isEditing && (account == initialAccount || !isValid)
                        }
                    )
                }.clicks handledBy {
                    if (isEditingStore.current) editStore.submitChangeBankAccountRequestIfValid(Unit)
                    else isEditingStore.update(true)
                }

                combine(
                    isEditingStore.data,
                    globalSubmitTracker.data,
                    ::Pair
                ).renderIf({ (isEditing, isSubmitting) ->
                    isEditing && !isSubmitting
                }) {
                    btn {
                        label("Abbrechen")
                        color(Btn.ColorScheme.Secondary)
                    }.clicks handledBy {
                        isEditingStore.update(false)
                        ibanStore.update(initialIban)
                    }
                }
            }
        }
    }
}